import React from "react";
import {Button, DatePicker, Form, message, Modal, Popconfirm} from "antd";
import {ServicePost, ServiceUpdate} from "../../../../models/service";
import {WorkOrderPost} from "../../../../models/workorder";

const FormItem = Form.Item;
const moment = require('moment');

class HotsheetDateUpdateForm extends React.Component {

  handleUpdateDate = () => {
    const row = this.props.row;
    const form = this.props.form;
    form.validateFields((err, values) => {
      if(!err){
        const service_date = moment(values['service_date']);
        ServiceUpdate(row.service.id, {'service_date': service_date.format('YYYY-MM-DD')})
          .then(response => {
            message.success('Service Date Updated successfully');
            response['service_date'] = response.next_service_date;
            response['waste_stream_copy'] = true;
            ServicePost(response)
              .then(service_response => {
                let data = {};
                data['generator'] = row.generator.id;
                data['bill_to'] = row.bill_to.id;
                data['user'] = row.user.id;
                data['service'] = [service_response.id];
                data['hotsheet_id'] = row.id;
                data['po'] = row.po;
                WorkOrderPost(data)
                  .then(workorder_response => {
                    message.success("Created Copy in WorkOrder")
                  })
              });
            this.props.fetch();
            this.props.setModelVisible(false)
          });
      }
    })
  };
  handleCancelDate = () => {
    const row = this.props.row;
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        const service_date = moment(values['service_date']);
        ServiceUpdate(row.service.id, {'service_date': service_date.format('YYYY-MM-DD')})
          .then(response => {
            message.success('Service Date Updated successfully');
            this.props.fetch();
            this.props.setModelVisible(false)
          })
      }
    })
  };

  render() {
    const text = 'Do you want to create a new work order for this Hotsheet?';
    const {row, visible} = this.props;
    const {getFieldDecorator} = this.props.form;
      return (
      <Modal title="Edit Date" width={500} centered visible={visible}
             footer={
               <div>
                <Button onClick={() => this.props.setModelVisible(false)}>Cancel</Button>
                <Popconfirm placement="top" onCancel={this.handleCancelDate} title={text} onConfirm={this.handleUpdateDate} okText="Yes" cancelText="No">
                  <Button type="primary">Update Date</Button></Popconfirm>
               </div>
             }
             destroyOnClose={true}>
        <div className={"edit-qty-modal edit-date"}>
          <Form>
            <div className="row">
              <div className="col-12">
                <h6>Date: </h6>
                <FormItem>
                    {getFieldDecorator('service_date', {
                      initialValue: moment(row.service.service_date),
                      rules: [{required: true, message: 'Please select generator'}],
                    })(<DatePicker />)}
                  </FormItem>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    )
  }
}

export const HotsheetDateUpdate = Form.create()(HotsheetDateUpdateForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/hotsheet_performed/HotsheetDateUpdate.jsx